<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3 text-left" style="padding-right: 0px;">
                    <label class="text-left">{{$Jed.firstUpperTranslate("user", 2)}}: {{$Jed.firstUpperTranslate("row") + ' ' + currentRow + ' ' + $Jed.translate("of") + ' ' + maxRows}}</label>
                </div>
                <div class="col-md-1 text-left" style="padding-left: 0px;">
                    <a style="cursor: pointer;" @click.prevent="addUserClick">
                        <i :class="$root.icons.plus" style="font-size: 1.8em;" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md">
                    <div class="form-group">
                        <div style="padding: 5px;">       
                            <grid :others="others" :columns="otherRequesterAttributesCfg.columns"
                                :source.sync="usersList" :options="options"
                                    :lang="$root.token.idLingua" :name="otherRequesterAttributesCfg.title" :rowClick="rowClicked"> 
                            </grid>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-7"></div> <!--<div class="col-md-3"></div>-->
                <div class="col-md-5"> <!--<div class="col-md-9">-->
                    <!--<div class="controls col-sm-4">
                        <button class="btn btn-primary-default" @click.prevent="addUserClick" style="width: 100%">{{otherRequesterLabels.addUserBtnLbl}}</button>
                    </div>-->
                    <div class="controls col-sm-6"> <!--<div class="controls col-sm-4">-->
                        <button class="btn btn-danger" @click.prevent="cancelClick" style="width: 100%">{{otherRequesterLabels.annullaBtnLbl}}</button>
                    </div>
                    <div class="controls col-sm-6"> <!--<div class="controls col-sm-4">-->
                        <button class="btn btn-primary-default" @click.prevent="confirmClick" style="width: 100%">{{otherRequesterLabels.confermaBtnLbl}}</button>
                    </div>
                </div>
            </div>
        </div>  
    </div>   
</template>

<script>

import { eventBus } from "../../../eventbus";
import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'

export default {
    components: {
        Grid
    },
    props:{
        usersList: Array
    },
    watch:{
        usersList: function(){
            this.maxRows = this.usersList.length
            this.currentRow = 1
        }
    },
    data: function () {
        var vm = this;
        return {
            otherRequesterLabels: {
                annullaBtnLbl: vm.$Jed.firstUpperTranslate("cancel"),
                confermaBtnLbl: vm.$Jed.firstUpperTranslate("confirm"),
                addUserBtnLbl: vm.$Jed.firstUpperTranslate("add user"),
            },
            options: {
                columnsresize: true,
                columnsreorder: true,
                rowsheight: 26,
                theme: "light",
                width: "100%",
                selectionmode: "singlerow",
                pageable: true,
                showfilterrow: false,
                filterable: true,
                sortable: true,
                pageable: false,
                autoheight: false,
                height: 210,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails:
                        "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                    rowdetailsheight: 250 /* ! 230 + 20 ! */
                },
                /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
                ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
                initrowdetails: "nested",
                rendered: null
            },
            others:{
                adaptColumns: true
            },
            otherRequesterAttributesCfg: {
                ID: "otherReqAttributesId",
                title: "TabellaUtenti",
                label_title: "",
                visible: true,
                columns: {
                    configs:{
                        del: {
                            text: '',
                            position: 1,
                            visible: true,
                            editable: false,
                            width: "5%",
                            datafield: "del",
                            iconcolumn: true,
                            geticonclass: function(obj){
                                if(obj && obj.pro == 1){ //l'utente con profilo amministratore non può essere eliminato
                                    return;
                                }else{
                                    return vm.$root.icons.close
                                }
                            },
                            onclick: function(obj, ev, i) {
                                var ok = function(){
                                        vm.$emit("onDeleteUserEvent", obj, i);
                                        this.close();
                                    },
                                    no = function(){
                                        this.close();
                                    },
                                    e = {
                                        message: vm.$Jed.firstUpperTranslate('selected user') + ': '+ obj.user + '<br>' + vm.$Jed.firstUpperTranslate('Do you want to delete it?'), 
                                        ok: ok,
                                        no: no
                                    }
                                if(obj && obj.pro == 1){ //l'utente con profilo amministratore non può essere eliminato
                                    return;
                                }else{
                                    eventBus.$emit("confirm", e) 
                                }
                            }
                        },
                        mod: {
                            text: '',
                            position: 2,
                            visible: true,
                            editable: false,
                            width: "5%",
                            datafield: "mod",
                            iconcolumn: true,
                            geticonclass: function(obj){
                                if(obj && obj.pro == 1){ //l'utente con profilo amministratore non può essere modificato
                                    return;
                                }else{
                                    return vm.$root.icons.edit
                                }
                            },
                            onclick: function(obj, ev, i) {
                                if(obj && obj.pro == 1){ //l'utente con profilo amministratore non può essere modificato
                                    return;
                                }else{
                                    vm.$emit("onOpenModifyUserEvent", obj);
                                }
                            }
                        },
                        nomecog: {
                            text: vm.$Jed.firstUpperTranslate("name")+' '+vm.$Jed.firstUpperTranslate("surname"),
                            position: 3,
                            visible: true,
                            editable: false,
                            width: "20%",
                            searchable: false,
                            sorting: true,
                            datafield: "userFullname"
                        },
                        utente: {
                            text: vm.$Jed.firstUpperTranslate('user'),
                            position: 4,
                            visible: true,
                            editable: false,
                            width: "15%", 
                            searchable: false,
                            sorting: true,
                            datafield: "user"
                        },
                        mail: {
                            text: vm.$Jed.firstUpperTranslate('email'),
                            position: 5,
                            visible: true,
                            editable: false,
                            width: "30%",
                            searchable: false,
                            sorting: true,
                            datafield: "email"
                        },
                        tel: {
                            text: vm.$Jed.firstUpperTranslate("phone"),
                            position: 6,
                            visible: true,
                            editable: false,
                            width: "15%",
                            searchable: false,
                            sorting: true,
                            datafield: "phone"
                        },
                        fax: {
                            text: vm.$Jed.firstUpperTranslate("fax"),
                            position: 7,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "fax"
                        }
                    }
                }
            },
            currentRow: 1,
            maxRows: 1,
            clicked_obj: null
        }
    },
    methods: {
        cancelClick() {
            this.$emit("onCancelOtherRequesterEvent");
        },
        confirmClick() {
            this.$emit("onConfirmOtherRequesterEvent", this.clicked_obj);
        },
        addUserClick(){
            this.$emit('onOpenAddUserEvent');
        },
        rowClicked(obj, index){
            this.clicked_obj = obj
            this.currentRow = index+1;
        }
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/OtherRequester.vue?92e06cec